<div id="modal-content-wrapper">
    <header id="modal-header">
        <h4 id="modal-title"><strong>Instructions for finding area of solar panels on your roof</strong></h4>
    </header>
    <section id="modal-body">
            <p>To find the total area of the prospective solar panel array you'd like installed on your roof, you'll need to use the drawing tool: </p>

            <video width="500" height="420" autoplay loop>
            <source src="../assets/panelarea.mp4" type="video/mp4" />
            </video>

            <p><strong>Important!</strong> Be sure that your shape is completely connected, and a "Total Area" calculation shows up on the map.</p>

    </section>
    <footer id="modal-footer">
        <button mat-flat-button class="okbutton" (click)="closeModal()">Okay, I got it.</button>
    </footer>
</div>
